export default __webpack_public_path__ + "static/Lazarek-9350766b4fa5c5ffd2a8669327d2306e.jpg";